import { createContext, useContext, useState, ReactNode } from "react";

interface RecordingOpportunityContextType {
  uploadSuccess: boolean;
  setUploadSuccess: (success: boolean) => void;
}

const RecordingOpportunityContext = createContext<
  RecordingOpportunityContextType | undefined
>(undefined);

export function RecordingOpportunityProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);

  return (
    <RecordingOpportunityContext.Provider
      value={{ uploadSuccess, setUploadSuccess }}
    >
      {children}
    </RecordingOpportunityContext.Provider>
  );
}

export function useRecordingOpportunity() {
  const context = useContext(RecordingOpportunityContext);
  if (context === undefined) {
    throw new Error(
      "useRecordingOpportunity must be used within a RecordingOpportunityContext",
    );
  }
  return context;
}
